import * as Factory from 'factory.ts'
import faker from 'faker'

import { RoleTypes } from '../../../entities/enums/RoleTypeEnum'
import { type UserRoleApiModel } from '../UserRoleApiModel'

export const UserRoleApiModelStub = Factory.Sync.makeFactory<UserRoleApiModel>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.name.jobTitle()),
  type: Factory.each(() => faker.random.arrayElement(Object.values(RoleTypes))),
})
